import React from "react"

import { Menu } from "./Menu"
import { CenteredLayout, TabsLayout, VerticalMenuLayout } from "@humanpredictiveintelligence/myqvt-library"
import { FeatureWithTabs, useNavigationTabs } from "./navigationTabs"

import backgroundHub from "assets/images/backgroundHub.avif"
import { SurveyContentTypeProvider } from "features/SurveyContentType/SurveyContentTypeContext"
import { SurveyContentType } from "models/generated"

export function withMenuLayout<Props>(
  WrappedComponent: React.ComponentType<Props>,
): React.ComponentType<Props> {
  const menuComponent = (
    <Menu
      menuBackgroundGradientTopColor={"#034acf"}
      menuBackgroundGradientBottomColor={"#236fff"}
    />
  )

  return (props) => (
    <VerticalMenuLayout menuChildren={menuComponent}>
      <WrappedComponent {...props} />
    </VerticalMenuLayout>
  )
}

export function withTabsLayout<Props>(
  WrappedComponent: React.ComponentType<Props>,
  feature: FeatureWithTabs,
  contentType?: SurveyContentType,
): React.ComponentType<Props> {
  const menuComponent = (
    <Menu
      menuBackgroundGradientTopColor={"#034acf"}
      menuBackgroundGradientBottomColor={"#236fff"}
    />
  )

  return (props) => {
    const tabs = useNavigationTabs(feature)

    return (
      <SurveyContentTypeProvider value={contentType}>
        <VerticalMenuLayout menuChildren={menuComponent}>
          <TabsLayout tabs={tabs}>
            <WrappedComponent {...props} />
          </TabsLayout>
        </VerticalMenuLayout>
      </SurveyContentTypeProvider>
    )
  }
}

export function withCenteredLayout<Props>(
  WrappedComponent: React.ComponentType<Props>,
  options?: WithCenteredLayoutProps,
): React.ComponentType<Props> {
  return (props) => (
    <CenteredLayout backgroundUrl={backgroundHub} {...options}>
      <WrappedComponent {...props} />
    </CenteredLayout>
  )
}

export interface WithCenteredLayoutProps {
  backgroundColor?: string,
  backgroundUrl?: string,
  header?: React.ReactChild,
  left?: React.ReactChild,
  right?: React.ReactChild,
  footer?: React.ReactChild,
}
